import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AlertColor } from '@mui/material';

interface AppSnackbarProps {
  open: boolean;
  severity: AlertColor;
  message: string;
  onClose: () => void;
  duration?: number;
}

const AppSnackbar: React.FC<AppSnackbarProps> = ({
  open,
  severity,
  message,
  onClose,
  duration = 6000
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        width: { xs: '250px', sm: '350px', md: '450px' },
        height: { xs: '125px', sm: '175px', md: '225px' },
        mx: 'auto',
        left: 0,
        right: 0
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          textAlign: 'center'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
